/* eslint-env browser */
/* eslint-disable prefer-arrow-callback */
window.addEventListener('load', function () {
  const linkElm = document.head.querySelector('link[rel=stylesheet][media=print]');
  if (linkElm) {
    linkElm.media = 'all';
  }
});
